module.exports = __webpack_public_path__ + "img/process-icon-active.c6f15f51.svg";